import Firestore from '../initFirebase'
import { debounce, delay } from 'lodash'
import { globalOnDemandVars } from '../../helper/context'
import {
  handleErrorInCatch,
  notSavedInAnonymous,
  notSavedInSharing,
  savingEnd,
  savingStart
} from '../../helper/functions'

export async function updateTreeNode (id, input, retryCount = 0) {
  if (globalOnDemandVars.isSharing()) {
    notSavedInSharing()
    return
  }
  if (globalOnDemandVars.userData().isAnonymous) {
    notSavedInAnonymous()
    return
  }

  if (!(globalOnDemandVars.isPixelMode())) {
    if (process.env.NODE_ENV !== 'production') {
      console.tron.display({
        name: 'updateTreeNode start',
        preview: id,
        value: {
          location: globalOnDemandVars.isPixelMode(),
          id,
          input
        }
      // , important: true
      })
    }
    // if (input.orderAsChild) {
    //   console.tron.log(`orderAsChild update ${input.orderAsChild} / treenode`)
    // }
    if (retryCount <= 20) {
      if (retryCount === 0) { savingStart() }
      try {
        await Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('TreeNodes').doc(id).update(input)
        savingEnd()
      } catch (e) {
        delay(() => {
          updateTreeNode(id, input, retryCount + 1)
        }, 500)
      }
    } else {
      handleErrorInCatch({}, 'updateData.js')
    }
  }
}
export const updateTreeNodeDebounced = debounce(updateTreeNode, 1000, { trailing: true, leading: true })
